export const lxyLangCn = {
    dashbordlxy: {
        welcome: '欢迎登陆系统',
        login: '登陆',
        logged:   "已登陆"

    },
    menuLxy: {
        lawyerFirmList: '律所页面'
    },
    lawyerLxy: {
        LawyerLetter: '律师函状态',
        LawyerStatus_UNDSend: "未发送", // 未发送
        LawyerStatus_Cancel: "撤回", // 撤回
        change: '修改状态',
        sendToOther: "转发三方律师函",
        Applycounts: "申请次数"
    },
    dataModulelxy: {
        dataModule: '数据模块',
        dataList: "工单数据",
        anomalyStatistics: "工单异常统计",
        loginOrnot: '是否登录',
        KeyIndicators: '关键指标',
        AuditCompleted: '审核完成量',
        uncomplete: '未完成工单量',
        passAmount: '通过量',
        invalidAmount: '失效量',
        rejectAmount: '拒贷量',
        passRate: '通过率',
        invalidRate: '失效率',
        rejectRate: '拒贷率',
        QualityCheckAmount: '质检抽查量',
        QualitypassAmount: '质检通过量',
        QualityjectAmount: '质检拒绝量',
        GenerateTicketAmount: '生成工单数',
        assignmentTicketAmount: '分配工单数',
        finishTicketAmount: '完成工单',
        passAmountAndRate: '通过量及占比',
        overruleAmountAndRate: '驳回量及占比',
        rejectAmountAndRate: '拒单量及占比',
        QualitypassAmountAndRate: '质检通过量及占比',
        QualityCheck: '质检',
        EveryItemTime: '件均处理时长',
        RankEmployeesGroup: '组内员工排名',
        TeamData: '团队数据',
        avgHandleTicketNum: '人均处理工单量',
        avgAnswerNum: '人均接通量',
        avgClosureAmount: '人均成交额',
        newOnceClosureNum: '新单一次',
        newNotOnceClosureNum : '新单非一次',
        oldClosureNum: '旧单',
        otherClosureNum: '其他',
        dailyClosureMetrics: '成交量(金额/率)',
    }

};
